export const isEmpty = (state) => state.messages.length === 0
